import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from './Context';
import Home from './components/Home';
import Navbar from './components/Navbar';  // Import Navbar
import Error from './components/Error';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/fonts.css'
import './css/w3.css';
import 'bootstrap/dist/css/bootstrap.css';
import './css/encora_theme.css';
import './css/custom.css';
import './css/icons.css';
import './app.css';
import Login from './components/login';
import { detectDeviceType } from './utils';
import Dashboard from './components/Dashboard';
import UserManagement from './components/attendees/UserManagement';
import Attendee from './components/attendees/attendee';
import EventManagement from './components/events/EventManagement';
import Events from './components/events/event';
import AttendeeMapping from './components/events/AttendeeMapping';

import AuthGuard from './components/AuthGaurd';

function App() {
  const isMobileDevice = detectDeviceType().toLowerCase() === 'mobile' ? true : false;
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  // Function to toggle Navbar visibility
  const toggleMenu = (bool) => {
    setIsMenuVisible(bool);
  }
  
  const showLoading = useCallback((value) => {
    setIsLoading(value);
  }, []); 
  
  // Simulate loading delay for demonstration

  return (
    <UserProvider>
      <Router>
        <AuthGuard>
        {isLoading ? ( // Conditionally render loader
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : <></>}
        <Navbar isMenuVisible={ isMenuVisible }/>
        <div className={`App ${isMobileDevice ? 'mobile' : ''}`}>
          <Routes>            
            <Route path="/" element={<Login toggleMenu={toggleMenu} showLoading={showLoading} />} />
            <Route path="/index" element={<Login toggleMenu={toggleMenu} showLoading={showLoading} />} />
            <Route path="/index.html" element={<Login toggleMenu={toggleMenu} showLoading={showLoading} />} />
            <Route path="/login" element={<Login toggleMenu={toggleMenu} showLoading={showLoading} />} />
            <Route path="/Home" element={<Home showLoading={showLoading} />} />
            <Route path="/dashboard" element={<Dashboard showLoading={showLoading} />} />
            <Route path="/user-management" element={<UserManagement showLoading={showLoading} />} />
            <Route path="/user-management/attendee" element={<Attendee showLoading={showLoading} />} />
            <Route path="/event-management" element={<EventManagement showLoading={showLoading} />} />
            <Route path="/event-management/event" element={<Events showLoading={showLoading} />} />
            <Route path="/event-management/attendee-mapping" element={<AttendeeMapping showLoading={showLoading} />} />
            <Route path="/Error" element={<Error />} />
          </Routes>

          <ToastContainer 
            position="bottom-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
        </AuthGuard>
      </Router>
    </UserProvider>
  );
}

export default App;
